/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  PERIOD_1_DIR_1,
  PERIOD_1_DIR_2,
  PERIOD_2_DIR_1,
  PERIOD_2_DIR_2,
  PERIOD_3_DIR_1,
  PERIOD_3_DIR_2,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import PeriodRow from './PeriodRow.jsx';

const periodMap = {
  1: {
    dir1: PERIOD_1_DIR_1,
    dir2: PERIOD_1_DIR_2,
  },
  2: {
    dir1: PERIOD_2_DIR_1,
    dir2: PERIOD_2_DIR_2,
  },
  3: {
    dir1: PERIOD_3_DIR_1,
    dir2: PERIOD_3_DIR_2,
  },
};

const mapStateToProps = (_, ownProps) => {
  const { period, form } = ownProps;
  const { makeFormFieldVisibilitySelector } = modelTypesByForm[form];
  const selectFormFieldVisibility = makeFormFieldVisibilitySelector();

  return state => ({
    showDir1: selectFormFieldVisibility(state)(periodMap[period].dir1),
    showDir2: selectFormFieldVisibility(state)(periodMap[period].dir2),
    dir1Field: periodMap[period].dir1,
    dir2Field: periodMap[period].dir2,
  });
};

export default connect(mapStateToProps)(PeriodRow);
